import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { showSelector } from 'selectors/testTarget/offers/percentOffFlagSale/show/showSelector';

const showPercentOffFlagSaleSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => {
    return testReady && show;
});

export { showPercentOffFlagSaleSelector };
